<div class="information-column">
    <div class="information-column__title">{{ title }}</div>
    <div class="information-column__description">{{ description }}</div>
    <ng-content></ng-content>
</div>
